import {inject, Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {SeoData} from '../model/seo.model';
import {blank} from '../common/strings';
import {environment} from '../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class SeoService {
  private title = inject(Title);
  private meta = inject(Meta);

  updateMetadata(data: SeoData) {
    const title = data.title || "7 minutes pour toi | Le speed dating qui prend le temps d'accepter tes nuances";
    const description = data.description || "Jusqu'à 9 rencontres vérifiées par soirée dans un lieu élégant et une ambiance décontractée";
    const image = data.image?.startsWith('http') ? data.image : `${environment.mediaDnsUrl}/assets/images/home/lets-meet/lets-meet-woman-top-2.webp`;
    const url = `${environment.apiUrl}/${data.url || blank}`;


    this.title.setTitle(title);
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'website'});
  }
}
